import React, { useEffect, useState } from "react";
import images from "constants/images";
import { CommonInput, CrossButton, CustomSelect } from "components";
export const TripReactTable = (props) => {
  const {
    data,
    columns,
    calBackOpen,
    freghtDetails,
    tableTitle,
    totalFreight,
    transactionList,
    callBackPayment
  } = props;

  const totalAmount = data.reduce(
    (total, item) =>
      total +
      parseInt(
        item?.credit_or_debit === 2 ? item?.debit_amount : item?.credit_amount
      ),
    0
  );

  const remaningBalance = transactionList?.freight_summary?.balance

  function checkBalance(balance) {
    if (balance > 0) {
      return "plus";   // Positive balance
    } else if (balance < 0) {
      return "minus";  // Negative balance
    } else {
      return "zero";   // Exactly 0
    }
  }


  const arryOptions = [
    { label: "Arjun", value: "01" },
    { label: "Anvit", value: "02" },
  ];

  const noTransactionStyle = {
    textAlign: "center",
    color: "#999",
    fontStyle: "italic",
    padding: "10px",
  };

  // const totalAmount = 0

  return (
    <>
      <div>
        {/* Apply the table props */}
        <div>
          <div className="anv_fr_detailHead">
            {/* <h4>
              <div className="_nW_h4Inner">
                Advance Freight

                <button
                  className="addAble_btn addClaim"
                onClick={() => calBackOpen("claim", true)}
                >
                  <div className="_otrIcon_imb">
                    <img src={images.RUPEE} alt="" />
                  </div>
                  <span>Add Freight</span>
                </button>

                <button
                  className="addAble_btn addClaim"
                onClick={() => calBackOpen("claim", true)}
                >
                  <div className="_otrIcon_imb">
                    <img src={images.RUPEE} alt="" />
                  </div>
                  <span>Pay Fuel</span>
                </button>

              </div>
              <span className="__rtAmt">50000.00</span>
            </h4> */}
            {freghtDetails?.vehicle_id?.vehicle_ownership === 2 ? (
              tableTitle === "freight" ? (
                <h4>
                  <div className="_nW_h4Inner">
                    Advance Freight
                    {freghtDetails?.trip_status != 5 && <button
                      className="addAble_btn addClaim"
                      onClick={() => calBackOpen("freight", true)}
                    >
                      <div className="_otrIcon_imb">
                        <img src={images.RUPEE} alt="" />
                      </div>
                      <span>Pay Advance</span>
                    </button>}
                    {freghtDetails?.trip_status != 5 && <button
                      className="addAble_btn addClaim"
                      onClick={() => calBackOpen("fuel_supplier", true)}
                    >
                      <div className="_otrIcon_imb">
                        <img src={images.RUPEE} alt="" />
                      </div>
                      <span>Pay Fuel</span>
                    </button>}
                  </div>
                  <span className={transactionList?.freight_summary?.advance_freight >= 0 ? 'greenFont_cls' : 'redFont_cls'}> ₹ {transactionList?.freight_summary?.advance_freight?.toFixed(2)}  </span>
                  {/* <span className="__rtAmt">
                    {transactionList?.freight_summary?.advance_freight?.toFixed(
                      2
                    )} ₹
                   </span>  */}
                </h4>
              ) : tableTitle === "supplierClaim" ? (
                <h4>
                  <div className="_nW_h4Inner">
                    Supplier Claims
                    {freghtDetails?.trip_status != 5 && <button
                      className="addAble_btn addClaim"
                      onClick={() => calBackOpen("claim", true)}
                    >
                      <div className="_otrIcon_imb">
                        <img src={images.CLAIMNEW.default} alt="" />
                      </div>
                      <span>Add Claims</span>
                    </button>}
                  </div>
                  <span className={(transactionList?.freight_summary?.receivable - transactionList?.freight_summary?.payble) >= 0 ? 'greenFont_cls' : 'redFont_cls'}>
                    {" "}
                    ₹ {((transactionList?.freight_summary?.receivable || 0) - (transactionList?.freight_summary?.payble || 0))?.toFixed(2)}
                  </span>
                </h4>
              ) : tableTitle === "BalanceFreight" ? (
                <h4>
                  <div className="_nW_h4Inner">
                    Balance Freight
                    {freghtDetails?.trip_status != 5 && <button
                      className="addAble_btn addClaim"
                      onClick={() => calBackOpen("freightBalance", true)}
                    >
                      <div className="_otrIcon_imb">
                        <img src={images.RUPEE} alt="" />
                      </div>
                      <span>{checkBalance(remaningBalance) === "plus" ? "Pay Balance" : "Receive Balance"}</span>
                    </button>}
                  </div>
                  <span className={(transactionList?.freight_summary?.balance_freight) >= 0 ? 'greenFont_cls' : 'redFont_cls'}>
                    ₹ {transactionList?.freight_summary?.balance_freight?.toFixed(
                      2
                    )}
                  </span>
                </h4>
              ) : tableTitle === "tds" ? (
                <h4>
                  <div className="_nW_h4Inner">
                    Tds
                    {/* <button
                      className="addAble_btn addClaim"
                      onClick={() => calBackOpen("freightBalance", true)}
                    >
                      <div className="_otrIcon_imb">
                        <img src={images.RUPEE} alt="" />
                      </div>
                      <span>Add Balance</span>
                    </button> */}
                  </div>
                  <span className={(transactionList?.freight_summary?.total_tds) >= 0 ? 'greenFont_cls' : 'redFont_cls'}>
                    ₹ {transactionList?.freight_summary?.total_tds?.toFixed(
                      2
                    )}
                  </span>
                </h4>
              ) : (
                <h4>
                  <div className="_nW_h4Inner">
                    Other Charges
                    {freghtDetails?.trip_status != 5 && <button
                      className="addAble_btn addClaim"
                      onClick={() =>
                        calBackOpen(
                          freghtDetails?.vehicle_id?.vehicle_ownership === 2
                            ? "expense"
                            : "ownexpense",
                          true
                        )
                      }
                    >
                      <div className="_otrIcon_imb">
                        <img src={images.RUPEE} alt="" />
                      </div>
                      <span>Other Charges</span>
                    </button>}
                  </div>
                  <span className={(transactionList?.freight_summary?.other_receipt - transactionList?.freight_summary?.other_expenses) >= 0 ? 'greenFont_cls' : 'redFont_cls'}>
                    {" "}
                    ₹ {(
                      (transactionList?.freight_summary?.other_receipt || 0) -
                      (transactionList?.freight_summary?.other_expenses || 0)
                    ).toFixed(2)}
                  </span>
                </h4>
              )
            ) : tableTitle === "tripCharge" ? (
              <h4>
                <div className="_nW_h4Inner">
                  Trip Charges
                  {freghtDetails?.trip_status != 5 && <button
                    className="addAble_btn addClaim"
                    onClick={() => calBackOpen("Charges", true)}
                  >
                    <div className="_otrIcon_imb">
                      <img src={images.RUPEE} alt="" />
                    </div>
                    <span>Add Charges</span>
                  </button>}
                  {freghtDetails?.trip_status != 5 && <button
                    className="addAble_btn addClaim"
                    onClick={() => calBackOpen("multi_expense", true)}
                  >
                    <div className="_otrIcon_imb">
                      <img src={images.RUPEE} alt="" />
                    </div>
                    <span>Multi Expense</span>
                  </button>}
                </div>
                <span className={Number(transactionList?.freight_summary?.receipt-transactionList?.freight_summary?.expenses) >= 0 ? 'greenFont_cls' : 'redFont_cls'}>
                  ₹ {Number(transactionList?.freight_summary?.receipt-transactionList?.freight_summary?.expenses).toFixed(2)}
                </span>
              </h4>
            ) : tableTitle === "DriverClaims" ? (
              <h4>
                <div className="_nW_h4Inner">
                  Driver Claims
                  {freghtDetails?.trip_status != 5 && <button
                    className="addAble_btn addClaim"
                    onClick={() => calBackOpen("claimOwn", true)}
                  >
                    <div className="_otrIcon_imb">
                      <img src={images.CLAIMNEW.default} alt="" />
                    </div>
                    <span>Add Claims</span>
                  </button>}
                </div>
                <span className={(transactionList?.freight_summary?.receivable -
                  transactionList?.freight_summary?.payble) >= 0 ? 'greenFont_cls' : 'redFont_cls'}>
                  {" "}
                  ₹ {(
                    (transactionList?.freight_summary?.receivable || 0) -
                    (transactionList?.freight_summary?.payble || 0)
                  )?.toFixed(2)}
                </span>
              </h4>
            ) : tableTitle === "BalanceFreight" ? (
              <h4>
                <div className="_nW_h4Inner">
                  Balance Freight
                  {freghtDetails?.trip_status != 5 && <button
                    className="addAble_btn addClaim"
                  // onClick={() => calBackOpen("claim", true)}
                  >
                    <div className="_otrIcon_imb">
                      <img src={images.RUPEE} alt="" />
                    </div>
                    <span>Add Balance</span>
                  </button>}
                </div>
                <span className="__rtAmt">50000.00</span>
              </h4>
            ) : tableTitle === "Fastag" ? (
              <h4>
                <div className="_nW_h4Inner">
                  Fastag Auto
                </div>
                {/* <span className={transactionList?.freight_summary?.fastag >= 0 ? 'greenFont_cls' : 'redFont_cls'}>  changes by manoj sir*/}
                <span className="redFont_cls">
                  ₹ {(-Number(transactionList?.freight_summary?.fastag || 0)).toFixed(2)}
                </span>

              </h4>
            ) : (
              <h4>
                <div className="_nW_h4Inner">
                  Other Charges
                  {freghtDetails?.trip_status != 5 && <button
                    className="addAble_btn addClaim"
                    onClick={() =>
                      calBackOpen(
                        freghtDetails?.vehicle_id?.vehicle_ownership === 2
                          ? "expense"
                          : "ownexpense",
                        true
                      )
                    }
                  >
                    <div className="_otrIcon_imb">
                      <img src={images.RUPEE} alt="" />
                    </div>
                    <span>Other Charges</span>
                  </button>}
                </div>
                <span className={(transactionList?.freight_summary?.other_receipt -
                  transactionList?.freight_summary?.other_expenses) >= 0 ? 'greenFont_cls' : 'redFont_cls'}>
                  ₹ {(
                    (transactionList?.freight_summary?.other_receipt || 0) -
                    (transactionList?.freight_summary?.other_expenses || 0)
                  )?.toFixed(2)}
                </span>
              </h4>
            )}
          </div>
          <table className="_trpTable_xd __nwdChn_flxTb">
            {/* <thead className="table_head_style">
              <tr>
                {columns.map((column, index) => (
                  <th key={index}>{column.Header}</th>
                ))}

                <th></th>
              </tr>
            </thead> */}
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={columns.length} style={noTransactionStyle}>
                    No Transaction
                  </td>
                </tr>
              ) : (
                data.map((row, rowIndex) => (
                  <tr key={rowIndex} onClick={() => {
                    callBackPayment(row)
                  }} style={{ cursor: 'pointer' }}>
                    {columns.map((column, colIndex) => (
                      <td key={colIndex}>{row[column.accessor]}</td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
            
          </table>
        </div>
      </div>
    </>
  );
};
